import { useState, useCallback } from "react";
import { useChat } from "../context/ChatContext";
import { FaComments } from "react-icons/fa";

function StartChat({ userId, username, name, avatar, className = "" }) {
  const { openChatModal } = useChat();
  const [isLoading, setIsLoading] = useState(false);

  const handleStartChat = useCallback(async () => {
    if (isLoading) return; // Prevent multiple clicks

    setIsLoading(true);
    try {
      // Open chat modal with pre-selected user
      const userInfo = {
        _id: userId,
        username: username,
        name: name,
        avatar: avatar,
      };

      openChatModal(userInfo);
    } catch (error) {
      console.error("Error opening chat:", error);
    } finally {
      // Add a small delay to prevent rapid state changes
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }
  }, [isLoading, userId, username, name, avatar, openChatModal]);

  return (
    <button
      onClick={handleStartChat}
      disabled={isLoading}
      className={`flex items-center justify-center space-x-2 px-3 sm:px-4 py-3 bg-[#f26522] text-white rounded-lg hover:opacity-90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed font-semibold leading-none ${className}`}
      title={`Start chat with ${name || username}`}
    >
      <FaComments className="w-4 h-4" />
      <span>{isLoading ? "Starting..." : "Message"}</span>
    </button>
  );
}

export default StartChat;
